import { Typography } from "@mui/material";
import { FC } from "react";

interface SectionTitleProps {
  title: string;
  marginBottom?: number;
  marginTop?: number;
}

const SectionYellowTitle: FC<SectionTitleProps> = ({
  title,
  marginBottom = 1,
  marginTop,
}) => {
  return (
    <Typography
      variant="subtitle2"
      align="left"
      sx={{
        color: (theme) => theme.palette.primary.main,
        mb: marginBottom,
        textTransform: "uppercase",
        letterSpacing: 1.5,
        fontWeight: 700,
        fontSize: { xs: 13, sm: 15 },
        mt: marginTop,
      }}
    >
      {title.toUpperCase()}
    </Typography>
  );
};

export default SectionYellowTitle;
